export const isOnServer = () => typeof window === 'undefined'
